// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import request from '../libs/request'
/**
 * @description banner
 */
export function getBanner () {
    return request({
        url: 'pc/get_banner',
        method: 'get'
    })
}


/**
 * @description 首页数据
 */
export function getIndexData(){
    return request({
        url: 'pc/get_index_data',
        method: 'get'
    })
}

/**
 * 获取墓型数据
 * @retins {*}
 * */
export function listGrave(data) {
   // return request.post("v1/listgrave", data);
   return request({
       url: 'v1/listgrave',
       method: 'post',
	   data: data
   });
}

















/**
 * @description 首页订单图表
 */
export function orderApi (params) {
    return request({
        url: 'home/order',
        method: 'get',
        params
    })
}

/**
 * @description 首页订单图表
 */
export function userApi () {
    return request({
        url: 'home/user',
        method: 'get'
    })
}

/**
 * @description 首页商品交易额排行
 */
export function rankApi () {
    return request({
        url: 'home/rank',
        method: 'get'
    })
}

export function checkAuth () {
    return request({
        url: 'check_auth',
        method: 'get'
    })
}



// WEBPACK FOOTER //
// ./src/api/index.js